<em
  class="material-icons color-blue-dark icon-calcel cursor"
  (click)="cerrarDialogo()"
  >cancel</em
>
<!-- <h1 mat-dialog-title>Confirmación</h1> -->
<div class="pt-10">
  <div class="d-flex d-flex--nowrap container-fluid container-mensaje color-blue-dark">
    <em class="material-icons mg-rht-5">info_outline</em>
    <p [innerHTML]="data.label">
    </p>
  </div>

  <div class="steps-cont_actions d-flex justify-content-center pt-10">
    <button
      type="button"
      id="Afiliacion_PTEC-afiliar-trabajador-regresar"
      title="Cancelar"
      class="u-btn u-btn--line r-hide"
      (click)="cerrarDialogo()"
    >
      <ng-container *ngIf="data.botones?.cancelar; else elseDataBotones1">{{
        data.botones.cancelar
      }}</ng-container
      ><ng-template #elseDataBotones1>Cancelar</ng-template>
    </button>

    <button
      type="button"
      id="afiliacion Button"
      title="Aceptar"
      [analyticsModel]="data.taggeo"
      class="u-btn u-btn--blue"
      (click)="confirmado()"
      appDebounceClick
    >
      <ng-container *ngIf="data.botones?.enviar; else elseDataBotones2">{{
        data.botones.enviar
      }}</ng-container>
      <ng-template #elseDataBotones2>Enviar</ng-template>
    </button>
  </div>
</div>
